<div
  class="animated-container overflow-hidden"
  [ngClass]="{
    'close-container': edit,
  }"
  #animationContainer
>
  <div
    #documentFieldElement
    class="document-field-container box-border flex py-2 px-3 gap-2 items-center rounded-[8px]"
    [ngClass]="{
      hovered: hovered,
    }"
  >
    <!-- Reference Icon -->
    <ui-icon name="id" size="16" mSize="16" [fill]="getIconColor()" />

    <!-- InputType Text Field Value -->
    <div class="input-type-container flex items-center justify-center relative">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        font-weight="regular"
      >
        {{ getDocumentTypeName(form.get('inputType')?.value) }}
      </ui-paragraph>
    </div>

    <!-- Input Text Field Value -->
    <div class="input-value-container relative">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        font-weight="regular"
      >
        {{ form.get('input')?.value }}
      </ui-paragraph>
    </div>

    <!-- Edit Button Action -->
    <button
      *ngIf="!edit && hovered"
      type="button"
      class="flex items-center justify-center w-4 h-4"
      (click)="onEdit()"
      matTooltip="Editar"
      [disabled]="!isActivated"
    >
      <ui-icon name="edit" [fill]="getIconColor()" size="16" mSize="16" />
    </button>
  </div>
</div>

<form
  *ngIf="edit"
  [formGroup]="form"
  class="document-form grid grid-flow-row bg-neutrals-0 rounded-[8px] p-3 box-border gap-4"
  [ngClass]="{
    'close-container': !edit,
  }"
  (submit)="onSubmit()"
>
  <div class="flex justify-center items-center">
    <ui-paragraph
      type="p12"
      mobile-type="p12"
      text-color="neutrals-700"
      font-weight="semibold"
    >
      Documento de Identidad
    </ui-paragraph>
  </div>

  <!-- Select Input Field -->
  <div class="flex flex-col gap-1">
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      [ngClass]="{
        error: form.get('inputType')?.errors,
      }"
      #inputTypeContainer
    >
      <ui-icon
        name="id"
        size="16"
        mSize="16"
        [fill]="getFormIconColor('inputType')"
      />
      <select
        formControlName="inputType"
        (focus)="inputTypeContainer.classList.add('focussed')"
        (blur)="inputTypeContainer.classList.remove('focussed')"
      >
        <option value="">Selecciona Documento de Identidad</option>
        <option
          [value]="docType.id.toString()"
          *ngFor="let docType of documentTypes"
        >
          {{ docType.name }}
        </option>
      </select>
    </div>
    <ui-paragraph
      class="px-1 box-border"
      type="p10"
      mobile-type="p10"
      text-color="critical-300"
      font-weight="regular"
      *ngIf="form.get('inputType')?.hasError('required')"
    >
      El tipo de documento es obligatorio.
    </ui-paragraph>
  </div>

  <!-- Input Text Field -->
  <div class="flex flex-col gap-1">
    <div
      class="unicon-form-input box-border flex px-3 py-2 gap-2 items-center rounded-[8px]"
      [ngClass]="{
        error: form.get('input')?.errors,
      }"
      #inputContainer
    >
      <ui-icon
        name="id"
        size="16"
        mSize="16"
        [fill]="getFormIconColor('input')"
      />
      <input
        type="text"
        placeholder="N° de Documento de Identidad"
        formControlName="input"
        [maxlength]="maxLength"
        (focus)="inputContainer.classList.add('focussed')"
        (blur)="inputContainer.classList.remove('focussed')"
      />
    </div>
    <ui-paragraph
      class="px-1 box-border"
      type="p10"
      mobile-type="p10"
      text-color="critical-300"
      font-weight="regular"
      *ngIf="form.get('input')?.hasError('required')"
    >
      Tu documento de identidad es obligatorio.
    </ui-paragraph>
    <ui-paragraph
      class="px-1 box-border"
      type="p10"
      mobile-type="p10"
      text-color="critical-300"
      font-weight="regular"
      *ngIf="
        form.get('input')?.hasError('pattern') &&
        !form.get('input')?.hasError('required')
      "
    >
      No es un formato válido para
      {{ getDocumentTypeName(form.get('inputType')?.value) }}.
    </ui-paragraph>
  </div>

  <div class="grid grid-flow-col gap-2">
    <button class="btn-cancel" type="button" (click)="onCancel()">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        Cancelar
      </ui-paragraph>
    </button>
    <button class="btn-submit" type="submit" [disabled]="!form.valid">
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        [textColor]="form.valid ? 'primary-700' : 'neutrals-0'"
        font-weight="semibold"
      >
        Guardar
      </ui-paragraph>
    </button>
  </div>
</form>
